//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import staticQuizDataImport from '../assets/QuizData.json'

export default {
  name: 'HelloWorld',
  data () {
    return {
      currentImageId: 1,
      currentImageUrl: "",
      currentQuestionId: 0,
      currentQuestion: "",
      currentAnswer1: "",
      currentAnswer2: "",
      answer1Check: false, 
      answer2Check: false, 
      answer3Check: false, 
      answerLegend: false,
      answerKrampe: false,
      answerNone: false,
      quizstart: '',
      quizend: '',
      fullQuizData: staticQuizDataImport,
      quizdata: {
        player: [ {
          name: "Kan Akca",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK_2015_Akca.jpg",
          apps: 1,
          goals: 0,
          seasons: [ "2. Bundesliga - 2014/2015" ]
        }, {
          name: "Kevin Akpoguma",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK_2016_Akpoguma.jpg",
          apps: 45,
          goals: 0,
          seasons: [ "2. Bundesliga - 2015/2016", "2. Bundesliga - 2016/2017" ]
        }, {
          name: "Jörg Albertz",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK-Albertz_-Joerg-2006-07.jpg",
          apps: 109,
          goals: 11,
          seasons: [ "1. Bundesliga - 1990/1991", "1. Bundesliga - 1991/1992", "2. Bundesliga - 1992/1993", 
                     "Regionalliga Nord - 2005/2006", "Regionalliga Nord - 2006/2007" ]
        }, {
          name: "Sergio Allievi",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK-Allievi_-Sergio-unten-1994-95.jpg",
          apps: 39,
          goals: 6,
          seasons: [ "Oberliga Nordrhein 1993/1994", "2. Bundesliga - 1994/1995" ]
        }, {
          name: "Nana Ampomah",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK_2019_Ampomah.jpg",
          apps: 12,
          goals: 0,
          seasons: [ "1. Bundesliga 2019/2020", "2. Bundesliga - 2020/2021" ]
        }, {
          name: "Anderson Soares de Oliviera",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK-Anderson-2009-10.jpg",
          apps: 32,
          goals: 2,
          seasons: [ "2. Bundesliga 2009/2010" ]
        }, {
          name: "Ken Asaeda",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK-Asaeda_-Ken-2007-08.jpg",
          apps: 1,
          goals: 0,
          seasons: [ "Regionalliga Nord 2007/2008" ]
        }, {
          name: "Kaan Ayhan",
          img: "https://www.f95.de/media/files/fotos/profis/personen/archiv/AK_2019_Ayhan.jpg",
          apps: 113,
          goals: 8,
          seasons: [ "2. Bundesliga 2016/2017", "2. Bundesliga - 2017/2018", "1. Bundesliga - 2018/2019", 
                     "1. Bundesliga - 2019/2020", "2. Bundesliga - 2020/2021" ]
        } ],
        questions: [
          {
            question: "War länger als eine Saison da?",
            figure: "season",
            answers: [ "ja", "nein" ]
          }, 
          {
            question: "Hat mehr oder weniger als [number] Tore erzielt?",
            questionAlt: "Hat überhaupt mal ein Tor erzielt?",
            figure: "goals",
            answers: [ "mehr", "weniger" ],
            answersAlt: [ "ja", "nein" ]
          }, 
          {
            question: "Mehr oder weniger als [number] Spiele gemacht?",
            questionAlt: "Hat überhaupt mal gespielt?",
            figure: "apps",
            answers: [ "mehr", "weniger" ],
            answersAlt: [ "ja", "nein" ]
          }, 
          {
            question: "Krampe oder Legende?", 
            figure: "opinion",
            answers: [ "Legende", "Krampe" ]
          }
        ],
      },
      mydismiss: null
    }
  }, 
  computed: {
    url() {
      return this.currentImageUrl
    },
    name() {
      return this.quizdata.player[this.currentImageId].name
    },
    question() {
      return this.currentQuestion
    },
    answerOption1() {
      return this.currentAnswer1
    },
    answerOption2() {
      return this.currentAnswer2
    }, 
    answer1Label() {
      return "Hat [number] Saison(s) gespielt".replace( "[number]", this.quizdata.player[this.currentImageId].seasons.length )
    }, 
    answer2Label() {
      return "Hat [number] Tor(e) erzielt".replace( "[number]", this.quizdata.player[this.currentImageId].goals )
    },
    answer3Label() {
      return "Hat [number] Spiel(e) gemacht".replace( "[number]", this.quizdata.player[this.currentImageId].apps )
    },
    getSelectedDecades() {
      return this.$store.getters.getSelectedDecades
    },
    getSelectedSeasons() {
      return this.$store.getters.getSelectedSeasons
    },
    getSelectedLeagues() {
        return this.$store.getters.getSelectedLeagues
    }
  },
  watch: {
    getSelectedDecades(/*newValue, oldData*/) {
      this.loadQuizData()
    }, 
    getSelectedSeasons(/*newValue, oldData*/) {
      this.loadQuizData()
    }, 
    getSelectedLeagues(/*newValue, oldData*/) {
      this.loadQuizData()
    }
  },
  created() {
    this.$q.loading.show()
    this.loadQuizData()

    this.updateQuestionLables()
    this.$q.loading.hide()
  },
  mounted() {
    
  },  
  methods: {
    loadQuizData: function() {
      this.$analytics.logEvent("loadQuizData");
      console.log("loadQuizData")

      var result = []
      var secondary = []
      this.fullQuizData.player.forEach(player => {
        var filter = false;
        player.seasons.forEach(season => {
          if ( this.getSelectedSeasons.includes(season.season) ) {
            filter = true
          }
        })

        if ( player.img != null && filter ) {
          if ( this.$store.getters.getPlayerPlayed.some( played => played.name === player.name ) ) {
            secondary.push(player)
          } else {
            result.push(player)
          }
        }
      })

      result = result.sort(function() { return Math.random()-0.5 })
      secondary = secondary.sort(function() { return Math.random()-0.5 })
      
      result = result.concat(secondary)
      
      this.quizdata.player = result

      this.currentImageId = 0
      
      this.updatecurrentImageId()
      

      console.log("LoadQuizData - finish")
    },
    updateQuestionLables() {
      if ( this.quizdata.questions[this.currentQuestionId].figure == "season" ) {
        this.currentQuestion = this.quizdata.questions[this.currentQuestionId].question
        this.currentAnswer1 = this.quizdata.questions[this.currentQuestionId].answers[0]
        this.currentAnswer2 = this.quizdata.questions[this.currentQuestionId].answers[1]
      } else if ( this.quizdata.questions[this.currentQuestionId].figure == "goals" ) {
        if ( this.quizdata.player[this.currentImageId].goals < 5) {
          this.currentQuestion = this.quizdata.questions[this.currentQuestionId].questionAlt
          this.currentAnswer1 = this.quizdata.questions[this.currentQuestionId].answersAlt[0]
          this.currentAnswer2 = this.quizdata.questions[this.currentQuestionId].answersAlt[1]
        } else {
          this.currentQuestion = this.quizdata.questions[this.currentQuestionId].question.replace("[number]", this.getAskedGoals(this.quizdata.player[this.currentImageId].goals))
          this.currentAnswer1 = this.quizdata.questions[this.currentQuestionId].answers[0]
          this.currentAnswer2 = this.quizdata.questions[this.currentQuestionId].answers[1]
        }
      } else if ( this.quizdata.questions[this.currentQuestionId].figure == "apps" ) {
        if ( this.quizdata.player[this.currentImageId].apps < 5) {
          this.currentQuestion = this.quizdata.questions[this.currentQuestionId].questionAlt
          this.currentAnswer1 = this.quizdata.questions[this.currentQuestionId].answersAlt[0]
          this.currentAnswer2 = this.quizdata.questions[this.currentQuestionId].answersAlt[1]
        } else {
          this.currentQuestion = this.quizdata.questions[this.currentQuestionId].question.replace("[number]", this.getAskedApps(this.quizdata.player[this.currentImageId].apps))
          this.currentAnswer1 = this.quizdata.questions[this.currentQuestionId].answers[0]
          this.currentAnswer2 = this.quizdata.questions[this.currentQuestionId].answers[1]
        }
      } else if ( this.quizdata.questions[this.currentQuestionId].figure == "opinion" ) {
        this.currentQuestion = this.quizdata.questions[this.currentQuestionId].question
        this.currentAnswer1 = this.quizdata.questions[this.currentQuestionId].answers[0]
        this.currentAnswer2 = this.quizdata.questions[this.currentQuestionId].answers[1]
      }
    },
    doNothing: function() {
      console.log("doNothing")
    }, 
    updatecurrentImageId: function() {
      this.$analytics.logEvent("Players Displayed")
      
      this.currentImageId += 1
      if ( this.currentImageId >= this.quizdata.player.length ) this.currentImageId = 0
      
      this.currentImageUrl = this.quizdata.player[this.currentImageId].img

      this.answer1Check = false
      this.answer2Check = false
      this.answer3Check = false
      this.answerLegend = false
      this.answerKrampe = false
      this.answerNone = false

      this.quizstart = this.getNow()
    }, 
    nextQuestion: function() {
      if ( this.currentQuestionId >= this.quizdata.questions.length-1 ) {
        this.currentQuestionId = 0;
      } else {
        this.currentQuestionId = this.currentQuestionId+1
      }
      this.updateQuestionLables()

      this.currentImageUrl = this.currentImageUrl +"?t="+Math.random()
    },
    countAnswer: function(answer) {
      var correctAnswer = false
      var correctAnswerInfo = false
      if ( this.quizdata.questions[this.currentQuestionId].figure == "season" ) {
        console.log("Real Seasons: "+this.quizdata.player[this.currentImageId].seasons.length)
        console.log("Asked Seasons: > 1")
        console.log("Answer: "+answer)
        this.answer1Check = (this.quizdata.player[this.currentImageId].seasons.length > 1) == answer
        correctAnswer = this.answer1Check
        correctAnswerInfo = this.quizdata.player[this.currentImageId].seasons.length + " Saison(s)"
        console.log("Outcome: "+this.answer1Check)


        this.$analytics.logEvent("Question 1 total");
        if ( this.answer1Check ) this.$analytics.logEvent("Question 1 correct answer");
      } else if ( this.quizdata.questions[this.currentQuestionId].figure == "goals" ) {
        if ( this.quizdata.player[this.currentImageId].goals < 5) {
          console.log("Real Goals: "+this.quizdata.player[this.currentImageId].goals)
          console.log("Asked Goals: > 0")
          console.log("Answer: "+answer)
          this.answer2Check = (this.quizdata.player[this.currentImageId].goals > 0) == answer
          console.log("Outcome: "+this.answer2Check)

          console.log("Test1: "+(false == false))
          console.log("Test2: "+(true == true))
        } else {
          console.log("Real Goals: "+this.quizdata.player[this.currentImageId].goals)
          console.log("Asked Goals: "+this.getAskedGoals(this.quizdata.player[this.currentImageId].goals))
          console.log("Answer: "+answer)
          this.answer2Check = (this.quizdata.player[this.currentImageId].goals < this.getAskedGoals(this.quizdata.player[this.currentImageId].goals)) == !answer
          console.log("Outcome: "+this.answer2Check)
        }        
        correctAnswerInfo = this.quizdata.player[this.currentImageId].goals + " Tor(e)"
        correctAnswer = this.answer2Check
        this.$analytics.logEvent("Question 2 total");
        if ( this.answer2Check ) this.$analytics.logEvent("Question 2 correct answer");
      } else if ( this.quizdata.questions[this.currentQuestionId].figure == "apps" ) {
        if ( this.quizdata.player[this.currentImageId].apps < 5) {
          console.log("Real Apps: "+this.quizdata.player[this.currentImageId].apps)
          console.log("Asked Apps: > 0")
          console.log("Answer: "+answer)

          this.answer3Check = (this.quizdata.player[this.currentImageId].apps > 0) == answer
          console.log("Outcome: "+this.answer3Check)
        } else {
          console.log("Real Apps: "+this.quizdata.player[this.currentImageId].apps)
          console.log("Asked Apps: "+this.getAskedApps(this.quizdata.player[this.currentImageId].apps))
          console.log("Answer: "+answer)
          this.answer3Check = (this.quizdata.player[this.currentImageId].apps < this.getAskedApps(this.quizdata.player[this.currentImageId].apps)) == !answer
          console.log("Outcome: "+this.answer3Check)
        }
        correctAnswerInfo = this.quizdata.player[this.currentImageId].apps + " Spiel(e)"
        correctAnswer = this.answer3Check
        this.$analytics.logEvent("Question 3 total");
        if ( this.answer3Check ) this.$analytics.logEvent("Question 3 correct answer");
      } else if ( this.quizdata.questions[this.currentQuestionId].figure == "opinon" ) {
        this.$analytics.logEvent("Question 4 total");
      }

      
      if ( this.mydismiss ) this.mydismiss()

      if ( this.currentQuestionId < 3 ) {
        this.mydismiss = this.$q.notify({
          message: correctAnswerInfo,
          position: ( answer ? 'bottom-left' : 'bottom-right' ),
          icon: ( correctAnswer ? 'check_box' : 'check_box_outline_blank' ),
          color: ( correctAnswer ? 'red' : 'lime' ),
          timeout: 3000
        }) 
      } else if ( this.currentQuestionId == 3 && answer != null ) {
        this.mydismiss = this.$q.notify({
          message: '',
          position: ( answer ? 'bottom-left' : 'bottom-right' ),
          icon: ( answer ? 'star' : 'sick' ),
          color: ( answer ? 'red' : 'lime' ),
          timeout: 500
        }) 
      }
    },
    getAskedGoals(realGoals) {
      var askedGoals
      if (realGoals < 10) {
        askedGoals = Math.round(realGoals / 10) * 10
        if ( Math.abs(askedGoals - realGoals) < 2 ) askedGoals += 10
        if ( askedGoals == realGoals ) askedGoals += 10
      } else if (realGoals < 20) {
        askedGoals = Math.round(realGoals / 20) * 20
        if ( Math.abs(askedGoals - realGoals) < 4 ) askedGoals += Math.sign(askedGoals - realGoals) * 10
        if ( askedGoals == realGoals ) askedGoals += 10
      } else if (realGoals < 40) {
        askedGoals = Math.round(realGoals / 40) * 40
        if ( Math.abs(askedGoals - realGoals) < 8 ) askedGoals += Math.sign(askedGoals - realGoals) * 20
        if ( askedGoals == realGoals ) askedGoals += 10
      } else {
        askedGoals = Math.round(realGoals / 60) * 60
        if ( Math.abs(askedGoals - realGoals) < 12 ) askedGoals += Math.sign(askedGoals - realGoals) * 30
        if ( askedGoals == realGoals ) askedGoals += 10
      }
      return askedGoals
    },
  getAskedApps(realApps) {
      var askedApps
      if (realApps < 10) {
        askedApps = Math.round(realApps / 10) * 10
        if ( Math.abs(askedApps - realApps) < 2 ) askedApps += 10
        if ( askedApps == realApps ) askedApps += 10
      } else if (realApps < 40) {
        askedApps = Math.round(realApps / 20) * 20
        if ( Math.abs(askedApps - realApps) < 4 ) askedApps += Math.sign(askedApps - realApps) * 10
        if ( askedApps == realApps ) askedApps += 10
      } else if (realApps < 80) {
        askedApps = Math.round(realApps / 40) * 40
        if ( Math.abs(askedApps - realApps) < 8 ) askedApps += Math.sign(askedApps - realApps) * 20
        if ( askedApps == realApps ) askedApps += 10
      } else {
        askedApps = Math.round(realApps / 60) * 60
        if ( Math.abs(askedApps - realApps) < 12 ) askedApps += Math.sign(askedApps - realApps) * 30
        if ( askedApps == realApps ) askedApps += 10
      }
      return askedApps
    },
    answer1: function({ reset }) {
      console.log("legende")

      this.countAnswer(true)

      this.nextQuestion()

      if (this.currentQuestionId == 0) {
        this.answerLegend = true; 

        var callHomeData = this.getPlayerPlayed()
      
        this.$analytics.logEvent("Players Legend");
        this.$store.dispatch("addPlayerPlayed", callHomeData);
        this.$store.dispatch("addLegend", this.quizdata.player[this.currentImageId]);
        this.$store.dispatch("updateQuestionStats", { q1: this.answer1Check,  q2: this.answer2Check, q3: this.answer3Check })
        this.callHome(callHomeData)

        this.updatecurrentImageId()
      }

      setTimeout(() => {
        console.log("nextCard")
        
        if ( reset ) reset()
      }, 100)
    },
    answer2: function({ reset }) {
      console.log("krampe")

      this.countAnswer(false)

      this.nextQuestion()

      if (this.currentQuestionId == 0) {
        this.answerKrampe = true; 

        var callHomeData = this.getPlayerPlayed()
      
        this.$analytics.logEvent("Players Krampe");
        this.$store.dispatch("addPlayerPlayed", callHomeData);
        this.$store.dispatch("addKrampe", this.quizdata.player[this.currentImageId]);
        this.$store.dispatch("updateQuestionStats", { q1: this.answer1Check,  q2: this.answer2Check, q3: this.answer3Check })
        this.callHome(callHomeData)

        this.updatecurrentImageId()
      }
    
      setTimeout(() => {
        console.log("nextCard")
        
        if ( reset ) reset()
      }, 100)
    },
    answer3: function({ reset }) {
      console.log("answer3")

      this.$analytics.logEvent("Players Regular");

      this.countAnswer(null)

      this.nextQuestion()

      if (this.currentQuestionId == 0) {
        this.answerNone = true;

        var callHomeData = this.getPlayerPlayed()

        this.$analytics.logEvent("Players Regular");
        this.$store.dispatch("addPlayerPlayed", callHomeData);
        this.$store.dispatch("updateQuestionStats", { q1: this.answer1Check,  q2: this.answer2Check, q3: this.answer3Check })

        this.callHome(callHomeData)
        this.updatecurrentImageId()
      }
    
      setTimeout(() => {
        console.log("nextCard")
        
        if ( reset ) reset()
      }, 100)
    }, 
    getPlayerPlayed: function() {
      var player = this.quizdata.player[this.currentImageId]

      this.quizend = this.getNow()

      var callHomeData = {
        player, 
        answer1: this.answer1Check,
        answer2: this.answer2Check,
        answer3: this.answer3Check,
        answerLegend: this.answerLegend,
        answerKrampe: this.answerKrampe,
        answerNone: this.answerNone,
        quizstart: this.quizstart,
        quizend: this.quizend,
        user: this.$store.getters.getUuid,
        host: window.location.host
      }

      return callHomeData
    },
    callHome: function(callHomeData) {
      this.$http.post(process.env.VUE_APP_QUIZPLAYED_URL, 
      JSON.stringify(callHomeData), 
      {
        headers: {
          'content-type': 'text/plain'
        }
      }).then(function (data) {
        console.log(data.bodyText)
      }, function(err) {
        console.log(err)
      })
    },
    getNow: function() {
      var isoDate = new Date()
      
      var result = isoDate.toISOString()

      return result
    },
    debug: function() {
      console.log(localStorage.getItem('selectedDecades'))

      JSON.parse(localStorage.getItem('selectedDecades'))
    }

  }
}
